import * as z from "zod";
import { apiTokenSchema } from "./types";

export const listApiTokens = {
  name: "listApiTokens" as const,
  input: z.object({}),
  output: z.object({ tokens: z.array(apiTokenSchema) }),
};
